import { useCallback } from 'react';
import { ProjectBaselineCreateRequest } from 'api/project';
import { formatDate, GanttType, getDueDateFromGantt } from '../helpers';

export const useBaselineRequestPayload = ({ ganttRef }: { ganttRef: any }) => {
  const getRecordDates = useCallback(() => {
    const ganttRecords: any[] = ganttRef?.ganttInstance.taskStore.allRecords;

    return ganttRecords.reduce(
      (prev, record) => {
        if (record.type === GanttType.ProjectPhaseBar) {
          return {
            ...prev,
            projectPhases: [
              ...prev.projectPhases,
              {
                projectPhaseId: record.data.data.id,
                startDate: formatDate(record.startDate),
                dueDate: getDueDateFromGantt(record),
              },
            ],
          };
        }
        if (
          record.type === GanttType.TaskBar ||
          record.type === GanttType.MilestoneBar
        ) {
          return {
            ...prev,
            tasks: [
              ...prev.tasks,
              {
                taskId: record.data.data.id,
                startDate: formatDate(record.startDate),
                dueDate: getDueDateFromGantt(record),
              },
            ],
          };
        }

        return prev;
      },
      { projectPhases: [], tasks: [] },
    );
  }, [ganttRef]);

  const getCreateRequestPayload = useCallback(
    (formValues) => {
      const recordDates = getRecordDates();

      const payload: ProjectBaselineCreateRequest = {
        baselineName: formValues.name,
        ...(formValues.notes ? { baselineNote: formValues.notes } : null),
        projectPhases: recordDates.projectPhases,
        tasks: recordDates.tasks,
      };

      return payload;
    },
    [getRecordDates],
  );

  return {
    getCreateRequestPayload,
  };
};
